/**
 * Production Planning List
 */

import { ProductionLine } from "./models/enums/production-line";
import { IPageLineDisplay } from "./models/lines/page-line-display";

    export const PRODUCTION_PLANNING_CURRENT_TAB                = 'PRODUCTION_PLANNING_CURRENT_TAB';

    /**
     * Action creator for updating the selected tab for production planning
     * @param pageData The new page data
     */
    export const updateSelectedProductionPlanningTab = (path: string) => ({
        type: PRODUCTION_PLANNING_CURRENT_TAB,
        payload: path
    });

/**
 * Line Management
 */

     export const PRODUCTION_LINE_MANAGEMENT_SELECT_LINE = 'PRODUCTION_LINE_MANAGEMENT_SELECT_LINE';

     /**
      * Action creator for updating the selected tab for production planning
      * @param pageData The new page data
      */
     export const updateSelectedLine = (line: IPageLineDisplay) => ({
         type: PRODUCTION_LINE_MANAGEMENT_SELECT_LINE,
         payload: line
     });
